import { FC, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { ConfirmButtons, CustomSelect, Modal } from "../../../ui";
import { Button, Flex, Typography } from "antd";
import { CommonContext } from "../../../app/context/CommonContext";
import { SvgIcon } from "../../../../shared/icons";
import "./index.less";
import { fullUserSelector, idArrExpectedToSee, teamSelector, userSelector } from "src/store/user";
import { useDispatch, useSelector } from "react-redux";
import { initiateAndGetAllUserInfo } from "src/store/user/asyncRequests";

interface ViewModalProps {
  onClose: () => void;
  open: boolean;
}

const fakeTeams = [
  {
    id: "1",
    name: "Team 1",
    type: "team",
    members: [
      {
        id: "1.1",
        name: "John Snow",
        type: "member",
      },
      {
        id: "1.2",
        name: "Tom Smith",
        type: "member",
      },
      {
        id: "1.3",
        name: "Elena Gilbert",
        type: "member",
      },
      {
        id: "1.4",
        name: "Ann Salvatore",
        type: "member",
      },
      {
        id: "1.5",
        name: "Mike Butko",
        type: "member",
      },
      {
        id: "1.6",
        name: "Sam Smith",
        type: "member",
      },
    ],
  },
  {
    id: "2",
    name: "Team 2",
    type: "team",
    members: [
      {
        id: "2.1",
        name: "Anna Golibenko",
        type: "member",
      },
      {
        id: "2.2",
        name: "Alec Smith",
        type: "member",
      },
      {
        id: "2.3",
        name: "Elena Gilbert",
        type: "member",
      },
      {
        id: "2.4",
        name: "Ann Salvatore",
        type: "member",
      },
      {
        id: "2.5",
        name: "Mike Butko",
        type: "member",
      },
      {
        id: "2.6",
        name: "Sam Smith",
        type: "member",
      },
    ],
  },
];

export const ViewModal: FC<ViewModalProps> = ({ open, onClose }) => {
  let { team_viewing_ids_now, custom_team_mem_viewing_ids, teamStatus, id: cliId, email, team_viewing_ids_now_arr } = useSelector(userSelector);
  const { idArrExpToSee } = useSelector(fullUserSelector);
  const dispatch = useDispatch();
  const [viewingNow, setViewingNow] = useState([cliId]);
  const handleSubmitBtnClick = () => {
    const teamIdArr = viewingNow?.length ? viewingNow : [cliId];
    dispatch(idArrExpectedToSee(teamIdArr));
    dispatch(initiateAndGetAllUserInfo({ tz: Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone, teamIdArr }));
    onClose();
  };
  const { clientWithTeam, hasTeam } = useSelector(teamSelector);
  const { pageInfo } = clientWithTeam;

  // const [loaded, setLoaded] = useState(false);
  const [viewOptions, setViewOptions] = useState([{ value: cliId, label: `Me: (${email})` }]);

  // useEffect(() => {
  //   console.log(viewingNow, "viewOptions");
  // }, [viewingNow]);

  useEffect(() => {
    console.log(idArrExpToSee, "idArrExpToSeeidArrExpToSee");
    if (idArrExpToSee) {
      // setViewingNow(idArrExpToSee?.length ? idArrExpToSee : [cliId]);
      setViewingNow(idArrExpToSee);
      // setLoaded(true);
    }
  }, [idArrExpToSee, open]);
  // useEffect(() => {
  //   if (team_viewing_ids_now_arr && !loaded) {
  //     setViewingNow(team_viewing_ids_now_arr?.length ? team_viewing_ids_now_arr : [cliId]);
  //     setLoaded(true);
  //   }
  // }, [team_viewing_ids_now_arr]);

  useEffect(() => {
    const options = [{ value: cliId, label: `Me (${email})` }];

    const teamCanLookAt = [...(pageInfo?.data?.team_members?.filter((tm) => tm?.id !== cliId) || [])];
    const teamMembers = teamCanLookAt?.map((tm) => {
      return {
        label: `Team Member: ${tm?.first_name?.charAt(0)?.toUpperCase() + tm?.first_name?.slice(1).toLowerCase()} ${
          tm?.last_name?.charAt(0)?.toUpperCase() + tm?.last_name?.slice(1).toLowerCase()
        } - ${tm?.email}`,
        value: tm?.id,
      };
    });
    options.push(...(teamMembers || []));

    setViewOptions(options);
  }, [custom_team_mem_viewing_ids, pageInfo?.data?.team_members]);

  const handleSelectedViewChange = (value: any) => {
    setViewingNow(value);
  };

  const [manageOpen, setManageOpen] = useState(false);

  return (
    <>
      {/* <Modal customClassName={"view-modal"} open={manageOpen} title={"Select View"} onCancel={() => setManageOpen(false)}>
        s
      </Modal>{" "} */}
      <Modal customClassName={"view-modal"} open={open && !manageOpen} title={"Select View"} onCancel={onClose}>
        <Typography.Paragraph>
          Select the team member or custom groups you want to view. You'll be able to see their analytics, campaigns, actions, and check responses.
          <br />
          <br />
        </Typography.Paragraph>
        <Flex vertical={true} gap={8}>
          <Flex justify="space-between" align="center" style={{ padding: "0 6px" }}>
            <Typography.Paragraph className={"label"}>View</Typography.Paragraph>{" "}
            <Button className={"link"} onClick={() => setViewingNow([cliId])}>
              Reset back to me
            </Button>
            {/* <Button className={"link"} onClick={() => setManageOpen(true)}>
              Manage View Groups
            </Button>  LATER ADD IT */}
          </Flex>
          <CustomSelect
            className={"view-select"}
            options={viewOptions}
            value={viewingNow}
            onChange={handleSelectedViewChange}
            mode="multiple"
            // onDeselect={(value) => {
            //   if (viewingNow.length <= 1) return;
            //   setViewingNow(viewingNow.filter((v) => v !== value));
            // }}
          />
        </Flex>
        <ConfirmButtons
          className={"confirm-buttons"}
          leftButtonTitle={"Back"}
          rightButtonTitle={"Show"}
          handleSubmit={handleSubmitBtnClick}
          onCancel={onClose}
          disabled={hasTeam && teamStatus === "basic"}
          disabledExplanation={hasTeam ? "You don't have a team in Meetz." : "You need to be an admin to edit team settings."}
        />
      </Modal>
    </>
  );
};
